/**
 * https://www.pdftron.com/api/web/Core.DocumentViewer.html#displayBookmark__anchor
 */
export default outline => {
  window.documentViewer.displayBookmark(outline);
};
